const MaintenanceSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <div className="inline-block px-4 py-2 bg-orange-50 rounded-full mb-6">
              <span className="text-orange-600 font-semibold text-sm">6. MAINTENANCE</span>
            </div>
            
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Services de Maintenance
            </h2>
            
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Nous offrons des services complets de maintenance pour les infrastructures industrielles, commerciales et résidentielles.
              </p>
              
              <p>
                Notre équipe de techniciens hautement qualifiés effectue des inspections régulières, des réparations, des entretiens préventifs et des services d'urgence.
              </p>
              
              <p>
                Nous comprenons l'importance de la fiabilité et de la durabilité des installations, c'est pourquoi nous mettons tout en œuvre pour assurer le bon fonctionnement et la sécurité des équipements de nos clients.
              </p>
            </div>

            <div className="mt-8 space-y-4">
              <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-search-eye-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Inspections Régulières</h4>
                  <p className="text-sm text-gray-600">Contrôles périodiques pour prévenir les pannes</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-fill text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Réparations & Entretien</h4>
                  <p className="text-sm text-gray-600">Interventions rapides et efficaces</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-alarm-warning-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Services d'Urgence</h4>
                  <p className="text-sm text-gray-600">Disponibles 24/7 pour vos besoins critiques</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Entretien Préventif</h4>
                  <p className="text-sm text-gray-600">Prolongez la durée de vie de vos équipements</p>
                </div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl order-1 lg:order-2">
            <img
              src="https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/dde3b04baec349162ef5b62a8cb399cc.jpeg"
              alt="Services de maintenance professionnels"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MaintenanceSection;